import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { AppShell, SessionHeartbeat } from '@bloo-team/core-shell'
import { useEntityPaletteRows } from '../../../components/palette-entity'
import { getSession, useSession, findCluster, identityFor } from '../../../lib/session'
import { WHATS_NEW } from '../../../whats-new'

/**
 * Tenant layout behind the session guard. Identity, org name and scope name all
 * come from the one Session object — no demo constants. The shell chrome is
 * `@bloo-team/core-shell`'s; the app contributes the palette's entity-search rows
 * (app domain code until E7) through the extraRows contract.
 */
function TenantLayout() {
  const { clusterId, scopeId } = Route.useParams()
  const session = useSession()
  const paletteExtraRows = useEntityPaletteRows(clusterId, scopeId)
  if (!session) return null

  const cluster = findCluster(session, clusterId)
  const scope = cluster?.scopes.find((s) => s.scopeId === scopeId)
  const identity = identityFor(session, clusterId, scopeId)

  return (
    <>
    {/* Revalidates the SSID on an interval and on tab focus: a token that
        died while the screen sat idle lands back on login instead of a
        stale page (finding D1 — fabric says 400, not 401, for a dead SSID). */}
    <SessionHeartbeat />
    <AppShell
      identity={identity}
      clusterId={clusterId}
      scopeId={scopeId}
      orgName={cluster?.clusterName ?? clusterId}
      scopeName={scope?.scopeName ?? scopeId}
      paletteExtraRows={paletteExtraRows}
      releases={WHATS_NEW.releases}
    >
      <Outlet />
    </AppShell>
    </>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId')({
  beforeLoad: () => {
    if (!getSession()) throw redirect({ to: '/auth/login', replace: true })
  },
  component: TenantLayout,
})
